import { makeStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import React from 'react';
import { TooltipClick } from '~components/tooltip';
import Input from './input';

const useStyles = makeStyles({
  tooltip: { padding: 0, backgroundColor: 'unset', maxWidth: 'unset' },

  '@global': { '.DayPicker': { marginTop: 2 } },
});

const InputWrapper = React.forwardRef((props, ref) => {
  const {
    disabled,
    open,
    onOpen,
    onClose,
    datePicker,
    InputProps,
    TooltipProps,
    ...otherProps
  } = props;

  const classes = useStyles();

  return (
    <TooltipClick
      title={datePicker}
      interactive
      placement="bottom-start"
      classes={{ tooltip: classes.tooltip }}
      {...TooltipProps}
      open={open}
      onOpen={onOpen}
      onClose={onClose}
      PopperProps={{ ...TooltipProps.PopperProps }}
      ref={ref}
      disabled={disabled}
    >
      <Input autoComplete="off" disabled={disabled} {...InputProps} {...otherProps} />
    </TooltipClick>
  );
});

InputWrapper.propTypes = {
  disabled: PropTypes.bool,
  open: PropTypes.bool,
  onOpen: PropTypes.func,
  onClose: PropTypes.func,
  datePicker: PropTypes.node.isRequired,
  InputProps: PropTypes.object,
  TooltipProps: PropTypes.object,
};

InputWrapper.defaultProps = {
  disabled: undefined,
  open: undefined,
  onOpen: undefined,
  onClose: undefined,
  InputProps: {},
  TooltipProps: {},
};

export default InputWrapper;
